import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import la from './../../assets/images/left-arrow.svg';
import ra from './../../assets/images/right-arrow.svg';

import img from "../../assets/images/socialmapping-img.png";
import CSI1 from "../../assets/images/CSI-Projects-1.jpg";
import CSI2 from "../../assets/images/CSI-Projects-2.jpg";
function SocialMapping() {
  const nextRef = useRef(null);
  const prevRef = useRef(null);

  return (
    <>
      <section className="socialMapping bg-gray-de px-3" id="socialMapping">
        <div className="container max-1330 mx-auto">
          <h2 className="text-green-38B652 mb-4">
            CSI Projects{" "}
            {/* <span className="d-block text-primary-green">Background</span> */}
          </h2>
          <div className="socialMapping-swiper w-100 position-relative">
            <div className="row g-5">
              <div className="col-md-7">
                <div className="CSI-Projects" id="CSI-Project">
                  <span className="d-block text-primary-green" style={{ fontSize: '20px', fontWeight: 700 }}>CSI Projects</span><br></br>
                  <div class="vertical-scrol">
                    <p>​​​​​​​​​​CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.
                    </p>
                    <p>
                      CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.
                    </p>
                    <p>
                      CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.
                    </p>
                    <p>
                      <span className="d-block text-primary-green" style={{ fontSize: '20px', fontWeight: 700 }}>​Other ​Projects​​</span>
                    </p>
                    <p>​​​​​​​​​​CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.
                    </p>
                    <ul className="trust">
                      <li><a href="#">Education​</a></li>
                      <li><a href="#">Water skills</a></li>
                      <li><a href="#">Creating champions changing lives​</a></li>
                    </ul>
                  </div>
                </div>

              </div>
              <div className="col-md-4 text-center">
                <img src={CSI1} className="img-fluid mx-auto" alt="" /><p></p>
                <img src={CSI2} className="img-fluid mx-auto" alt="" />
              </div>

            </div>
            {/* <Swiper
                modules={[Navigation]}
                slidesPerView= {1}
                spaceBetween={0}
                navigation={{
                nextEl: ".custom-testimonials-next", // Custom next button
                prevEl: ".custom-testimonials-prev", // Custom prev button
              }}
              
              
              onInit={(swiper) => {
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
              className="mySwiper card-list"
            >
              <SwiperSlide>
                
                <div className="row g-5">
                  <div className="col-md-7">
                    <span className="d-block text-primary-green" style={{fontSize: '20px',fontWeight: 700}}>Corporate Social Investments</span><br></br>
                    <div class="vertical-scrol" id="SocialMapping">
                    <p>                      
                    ​​​​SAMSA's vision and objective is to lead and champion South Africa's maritime interests as a custodian and steward of maritime policy, to be the vigorous promoter of the maritime sector and give full and complete effect to its obligations for the benefit of all stakeholders.
                    </p>
                    <p>
                      Consistent with this and in compliance with the country's national development plans and attendant legislation encompassing wholesome social and economic development involving empowerment and upliftment of people, SAMSA's Corporate Social Investment is positioned to play a pivotal role.

                    </p>
                    <p>
                      Precisely, SAMSA's CSI contributes through community focused programmes that seek to encourage new entrants into the maritime industry, educate both the shoreline and inland-based population about the importance of all South Africa's waterways and about the necessity for proper utilisation of these safely, whether for work or leisure activities
                    </p>
                    <p>
                     SAMSA's CSI further supports the sustainability of subsistence-based shore communities, especially those impacted by climate change and maritime activities, co-ordinates efforts of multiple stakeholder groups with an interest in maritime safety and the environment through social mapping, and throughout all these, SAMSA employees are constantly engaged directly or indirectly to sustain their enthusiasm to live SAMSA's values.
                    </p>
                    <ul className="trust">
                    <li><a href="#">Education​</a></li>
                    <li><a href="#">Water skills developmen</a></li>
                    <li><a href="#">Entrepreneurial focus</a></li>
                    </ul></div>
                  </div>
                  <div className="col-md-5 text-center">
                    <img src={img} className="img-fluid mx-auto" alt="" />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="row g-5">
                  <div className="col-md-7">
                    <span className="d-block text-primary-green" style={{fontSize: '20px',fontWeight: 700}}>Social Mapping</span><br></br>
                    <p>
                    <span className="d-block text-primary-green">Background</span>
                    </p>
                    <div class="vertical-scrol" id="SocialMapping">
                    <p>Social mapping is a major initiative which strategically supports SAMSA’s services to society – through its services to government, its technical services to the marine and maritime industry, and to its stakeholders. 
                    </p>
                    <p>Government departments, non-profit organisations, and even other major corporates all impact directly on communities. By mapping the services relating to the affected communities, development practitioners can assess community needs and co-ordinate efforts to assist communities with their upliftment, thus greatly leveraging the value of social investment.
                    </p>
                    <p>SAMSA is a full member of Trialogue’s GIS mapping project for the entire South Africa, populated with detailed information on demographics, infrastructure, schools, health clinics, etc. By supporting SAMSA with the mapping of relevant information to its own needs, the company will be making a significant contribution to society at large and the maritime communities in particular.
                    </p>
                    <p>Through this site, we welcome visitors wishing to browse the location and basic information of our projects, registered users may conduct detailed research using the social map’s many layers of development information, or you can help us update the social map by sending in GIS information on your project.
                    </p>
                    <p>
                    <span className="d-block text-primary-green">Visitors</span>
                    </p>
                    <p>Here we intend to put up a basic map of South Africa with pins on it showing the location of SAMSA’s projects only. 
                    </p>
                    <p>
                      When you mouse over a pin, it will give the name of the project. When you click on it, you will be taken to that project’s page where the project is described with pics, etc.
                    </p>
                    <p>
                    <span className="d-block text-primary-green">Registered users</span>
                    </p>
                    <p>Here we intend to provide a log-in for registered users to log in to the social map, thus taking them to Trialogue’s Social Mapping tool. There must be some sort of SAMSA identity as part  of this process.
                   </p>
                    <p>
                       <span className="d-block text-primary-green">Help us update the social map</span>
                    </p>
                    <p>Send us an email with the particulars of your project and we will update the social map, making available to all interested stakeholders the vital information necessary to co-ordinate development efforts.
                      </p>
                      <p>
                        Update now and thereby assist communities with their upliftment, thus greatly leveraging the value of your social investment.
                      </p></div>

                  </div>
                  <div className="col-md-5 text-center">
                    <img src={img} className="img-fluid mx-auto" alt="" />
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="row g-5">
                  <div className="col-md-7">
                    <div className="CSI-Projects" id="CSI-Project">
                      <span className="d-block text-primary-green" style={{fontSize: '20px',fontWeight: 700}}>CSI Projects</span><br></br>
                    <div class="vertical-scrol" id="SocialMapping">
                    <p>​​​​​​​​​​CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.​​​​
                    </p>
                    <p>
                     ​​​​CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.​​
                    </p>
                    <p>
                     ​​​​​CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.​​
                    </p>
                    <p>
                     <span className="d-block text-primary-green" style={{fontSize: '20px',fontWeight: 700}}>​Other ​Projects​​</span>
                    </p>
                    <p>​​​​​​​​​​CERTIFIED: SAMSA Head of Corporate Social Investment, Ms Mapitso Dlepu (front in red shirt) celebrating with a group of youths in KwaZulu-Natal after they were awarded their training completion certificates in boat repairing at Inanda in 2019 – an initiative conducted jointly with the Natal Sharks Board.​​​​
                    </p>
                    <ul className="trust">
                    <li><a href="#">Education​</a></li>
                    <li><a href="#">Water skills</a></li>
                    <li><a href="#">Creating champions changing lives​</a></li>
                    </ul></div>
                    </div>
                    
                  </div>
                  <div className="col-md-4 text-center">
                    <img src={CSI1} className="img-fluid mx-auto" alt="" /><p></p>
                    <img src={CSI2} className="img-fluid mx-auto" alt="" />
                  </div>
                  
                </div>
              </SwiperSlide>
            </Swiper> */}
            <div className="socialMapping-navigation">
              {/* Custom Navigation Buttons */}
              {/* <button ref={prevRef} className="custom-testimonials-prev">
                <img src={la} alt="" className="" />
              </button>
              <button ref={nextRef} className="custom-testimonials-next">
                <img src={ra} alt="" className="" />
              </button> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SocialMapping;